import {useEffect,useState} from 'react';

/** Only a signed Stripe TEST webhook can turn this profile return into paid. */
export function StaffSalePaymentReturn({customerId}:{customerId:string}){
  const params=new URLSearchParams(window.location.search);
  const orderId=params.get('order')??'';
  const location=params.get('location')??'';
  const returnKind=params.get('staffCheckout');
  const valid=Boolean(returnKind&&
    /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(orderId)&&
    /^[A-Z0-9_-]{2,64}$/.test(location));
  const [status,setStatus]=useState('');
  const [problem,setProblem]=useState('');
  useEffect(()=>{
    if(!valid||!customerId)return;
    let active=true;
    const check=async()=>{
      try{
        const response=await fetch('/api/v1/staff/sales/stripe/test-orders/'+
          encodeURIComponent(orderId)+'?'+new URLSearchParams({
            location,customerId,
          }),{credentials:'same-origin',cache:'no-store'});
        const data=await response.json() as {ok:boolean;data?:{
          status:string;paid:boolean;fulfilled:boolean}};
        if(!response.ok||!data.ok||!data.data)
          throw Error('Payment record is not available to this staff account.');
        if(active){setStatus(data.data.fulfilled?'FULFILLED':
          data.data.paid?'PAID_UNFULFILLED':data.data.status);setProblem('');}
      }catch{if(active)setProblem('Unable to verify Stripe TEST payment yet.');}
    };
    void check();
    const interval=window.setInterval(()=>{
      if(status!=='FULFILLED')void check();
    },3000);
    return ()=>{active=false;window.clearInterval(interval);};
  },[valid,customerId,location,orderId,status]);
  if(!valid)return null;
  return <section className="ecfs-sale-receipt" role="region"
    aria-label="Staff Stripe TEST sale result">
    <h3>Stripe TEST Card Payment</h3>
    {status==='FULFILLED'
      ?<p role="status">Payment verified. Purchased service credits have been issued to this person.</p>
      :status==='PAID_UNFULFILLED'
        ?<p role="status">Stripe payment recorded. Credit fulfillment is processing.</p>
        :<p role="status">{returnKind==='cancelled'
          ?'Checkout was cancelled. No verified payment has been recorded.'
          :'Returned from Stripe. Payment is not yet verified.'}</p>}
    {problem&&<p role="alert">{problem}</p>}
    <small>Order: {orderId}</small>
  </section>;
}
